'use client'
var groups = {
	argentx: {
		brand: {
			alt: "ArgentX",
			primaryColor: "#FF875B",
			spriteId: "argentx"
		},
		key: "argentx",
		name: "ArgentX"
	},
	backpack: {
		brand: {
			alt: "Backpack",
			spriteId: "backpack"
		},
		key: "backpack",
		name: "Backpack"
	},
	bitgetwallet: {
		brand: {
			alt: "Bitget Wallet",
			spriteId: "bitget"
		},
		key: "bitgetwallet",
		name: "Bitget"
	},
	blocto: {
		brand: {
			alt: "Blocto",
			primaryColor: "#5E678A",
			spriteId: "blocto"
		},
		key: "blocto",
		name: "Blocto"
	},
	brave: {
		brand: {
			alt: "Brave Browser",
			primaryColor: "#4B49C6",
			spriteId: "brave"
		},
		key: "brave",
		name: "Brave"
	},
	coin98: {
		brand: {
			alt: "Coin98 Wallet",
			primaryColor: "#CDA349",
			spriteId: "fc460647-ea95-447a-99f0-1bff8fa4be00"
		},
		key: "coin98",
		name: "Coin98"
	},
	coinbase: {
		brand: {
			alt: "Coinbase Wallet",
			primaryColor: "#1648F9",
			spriteId: "coinbase"
		},
		key: "coinbase",
		name: "Coinbase"
	},
	compasswallet: {
		brand: {
			alt: "Compass",
			primaryColor: "#4B49C6",
			spriteId: "1d7dea00-96be-4ce8-ca15-d14bddbb5000"
		},
		key: "compasswallet",
		name: "Compass"
	},
	exodus: {
		brand: {
			alt: "Exodus Wallet",
			spriteId: "exodus"
		},
		key: "exodus",
		name: "Exodus"
	},
	fireblocks: {
		brand: {
			alt: "Fireblocks",
			spriteId: "fireblocks"
		},
		key: "fireblocks",
		name: "Fireblocks"
	},
	flowwallet: {
		brand: {
			alt: "Flow Wallet",
			primaryColor: "#2BE829",
			spriteId: "flowwallet"
		},
		key: "flowwallet",
		name: "Flow Wallet"
	},
	keplr: {
		brand: {
			alt: "Keplr",
			spriteId: "keplr"
		},
		key: "keplr",
		name: "Keplr"
	},
	magiceden: {
		brand: {
			alt: "Magic Eden",
			spriteId: "magiceden"
		},
		key: "magiceden",
		name: "Magic Eden"
	},
	mathwallet: {
		brand: {
			alt: "MathWallet Wallet",
			spriteId: "26a8f588-3231-4411-60ce-5bb6b805a700"
		},
		key: "mathwallet",
		name: "Math Wallet"
	},
	metamask: {
		brand: {
			alt: "MetaMask",
			primaryColor: "#E2761B",
			spriteId: "metamask"
		},
		key: "metamask",
		name: "MetaMask"
	},
	nightly: {
		brand: {
			alt: "Nightly Wallet",
			spriteId: "nightly"
		},
		key: "nightly",
		name: "Nightly"
	},
	okxwallet: {
		brand: {
			alt: "OKX Wallet",
			spriteId: "okx"
		},
		key: "okxwallet",
		name: "OKX Wallet"
	},
	onekey: {
		brand: {
			alt: "OneKey Wallet",
			spriteId: "onekey"
		},
		key: "onekey",
		name: "OneKey"
	},
	phantom: {
		brand: {
			alt: "Phantom",
			primaryColor: "#4B49C6",
			spriteId: "phantom"
		},
		key: "phantom",
		name: "Phantom"
	}
};
var wallets = {
	metamask: {
		brand: {
			alt: "MetaMask Wallet",
			primaryColor: "#E8831D",
			spriteId: "metamask"
		},
		chainGroup: "metamask",
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:42161",
			"eip155:42170",
			"eip155:7777777",
			"eip155:80084",
			"eip155:80085",
			"eip155:8453"
		],
		desktop: {
			chromeId: "nkbihfbeogaeaoehlefnkodbefgpgknn",
			edgeId: "ejbalbakoplchlghecdalmeeeajnimhm",
			firefoxId: "ether-metamask"
		},
		eip6963Config: {
			rdns: "io.metamask"
		},
		filterFromWalletConnect: true,
		group: "metamask",
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
					{
						flag: "isMetaMask",
						value: true
					},
					{
						flag: "isDawn",
						value: false
					},
					{
						flag: "isBraveWallet",
						value: false
					},
					{
						flag: "isTrustWallet",
						value: false
					},
					{
						flag: "isExodus",
						value: false
					},
					{
						flag: "isZerion",
						value: false
					},
					{
						flag: "isSuperb",
						value: false
					},
					{
						flag: "isRabby",
						value: false
					},
					{
						flag: "isOKExWallet",
						value: false
					},
					{
						flag: "isOkxWallet",
						value: false
					},
					{
						flag: "isRainbow",
						value: false
					},
					{
						flag: "isAvalanche",
						value: false
					},
					{
						flag: "isMagicEden",
						value: false
					},
					{
						flag: "isZerion",
						value: false
					},
					{
						flag: "isOneKey",
						value: false
					},
					{
						flag: "isPhantom",
						value: false
					},
					{
						flag: "isCoin98",
						value: false
					},
					{
						flag: "isBinance",
						value: false
					}
				]
			}
		],
		mobile: {
			androidId: "io.metamask",
			inAppBrowser: "https://metamask.app.link/dapp",
			iosId: "id1438144202",
			native: "metamask://wc",
			universal: "https://metamask.app.link/wc"
		},
		name: "MetaMask",
		shortName: "MetaMask",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	coinbase: {
		brand: {
			alt: "Coinbase Wallet",
			primaryColor: "#1648F9",
			spriteId: "coinbase"
		},
		chainGroup: "coinbase",
		desktop: {
			chromeId: "hnfanknocfeofbddgcijnmhnfnkdnaad"
		},
		eip6963Config: {
			rdns: "com.coinbase.wallet"
		},
		group: "coinbase",
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
					{
						flag: "isCoinbaseWallet",
						value: true
					}
				],
				windowLocations: [
					"coinbaseWalletExtension"
				]
			}
		],
		mobile: {
			androidId: "org.toshi",
			iosId: "id1278383455"
		},
		name: "Coinbase",
		shortName: "Coinbase Wallet"
	},
	coinbasesolana: {
		brand: {
			alt: "Coinbase Wallet",
			primaryColor: "#1648F9",
			spriteId: "coinbase"
		},
		chainGroup: "coinbase",
		desktop: {
			chromeId: "hnfanknocfeofbddgcijnmhnfnkdnaad"
		},
		group: "coinbase",
		injectedConfig: [
			{
				chain: "sol",
				extensionLocators: [
				],
				windowLocations: [
					"coinbaseSolana"
				]
			}
		],
		mobile: {
			androidId: "org.toshi",
			inAppBrowser: "cbwallet://dapp?url={{encodedDappURI}}",
			iosId: "id1278383455"
		},
		mobileExperience: "in-app-browser",
		name: "Coinbase",
		shortName: "Coinbase Wallet (Solana)",
		walletLimitations: {
			browserExtension: {
				unsupportedMethods: [
					"getConnectedAccounts"
				]
			}
		}
	},
	phantom: {
		brand: {
			alt: "Phantom Wallet",
			primaryColor: "#4B49C6",
			spriteId: "phantom"
		},
		chainGroup: "phantom",
		desktop: {
			chromeId: "bfnaelmomeimhlpmgjnjophhpkkoljpa",
			firefoxId: "phantom-app"
		},
		group: "phantom",
		hardwareWallets: [
			"ledger"
		],
		injectedConfig: [
			{
				chain: "sol",
				extensionLocators: [
					{
						flag: "isPhantom",
						value: true
					},
					{
						flag: "isBraveWallet",
						value: false
					},
					{
						flag: "isExodus",
						value: false
					},
					{
						flag: "isMagicEden",
						value: false
					},
					{
						flag: "isGlow",
						value: false
					},
					{
						flag: "isOKExWallet",
						value: false
					},
					{
						flag: "isOkxWallet",
						value: false
					}
				],
				walletStandardLocators: [
					{
						locator: "features.phantom:.phantom",
						name: "Phantom"
					}
				],
				windowLocations: [
					"phantom.solana"
				]
			}
		],
		mobile: {
			androidId: "app.phantom",
			iosId: "id1598432977"
		},
		mobileExperience: "in-app-browser",
		name: "Phantom"
	},
	phantombtc: {
		brand: {
			alt: "Phantom Wallet",
			primaryColor: "#4B49C6",
			spriteId: "phantom"
		},
		chainGroup: "phantom",
		desktop: {
			chromeId: "bfnaelmomeimhlpmgjnjophhpkkoljpa",
			firefoxId: "phantom-app"
		},
		group: "phantom",
		injectedConfig: [
			{
				chain: "btc",
				extensionLocators: [
					{
						flag: "isPhantom",
						value: true
					}
				],
				walletStandard: {
					features: [
						"bitcoin:connect"
					],
					name: "Phantom"
				},
				windowLocations: [
					"phantom.bitcoin"
				]
			}
		],
		mobile: {
			androidId: "app.phantom",
			iosId: "id1598432977"
		},
		name: "Phantom",
		shortName: "Phantom (Bitcoin)"
	},
	phantomevm: {
		brand: {
			alt: "Phantom Wallet",
			primaryColor: "#4B49C6",
			spriteId: "phantom"
		},
		chainGroup: "phantom",
		desktop: {
			chromeId: "bfnaelmomeimhlpmgjnjophhpkkoljpa",
			firefoxId: "phantom-app"
		},
		group: "phantom",
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
					{
						flag: "isPhantom",
						value: true
					}
				],
				windowLocations: [
					"phantom.ethereum"
				]
			}
		],
		mobile: {
			androidId: "app.phantom",
			iosId: "id1598432977"
		},
		name: "Phantom",
		shortName: "Phantom (EVM)"
	},
	phantomledger: {
		brand: {
			alt: "Phantom Wallet",
			primaryColor: "#4B49C6",
			spriteId: "phantom"
		},
		chainGroup: "phantom",
		desktop: {
			chromeId: "bfnaelmomeimhlpmgjnjophhpkkoljpa",
			firefoxId: "phantom-app"
		},
		group: "phantom",
		injectedConfig: [
			{
				chain: "sol",
				extensionLocators: [
					{
						flag: "isPhantom",
						value: true
					},
					{
						flag: "isBraveWallet",
						value: false
					},
					{
						flag: "isExodus",
						value: false
					},
					{
						flag: "isMagicEden",
						value: false
					},
					{
						flag: "isGlow",
						value: false
					},
					{
						flag: "isOKExWallet",
						value: false
					},
					{
						flag: "isOkxWallet",
						value: false
					}
				],
				walletStandardLocators: [
					{
						locator: "features.phantom:.phantom",
						name: "Phantom"
					}
				],
				windowLocations: [
					"phantom.solana"
				]
			}
		],
		mobile: {
			androidId: "app.phantom",
			iosId: "id1598432977"
		},
		name: "Phantom",
		shortName: "Phantom (Ledger)"
	},
	walletconnect: {
		brand: {
			alt: "WalletConnect",
			primaryColor: "#3182CE",
			spriteId: "walletconnect"
		},
		mobile: {
			androidId: "enable-android",
			iosId: "id1438144202"
		},
		name: "WalletConnect",
		shortName: "WalletConnect"
	},
	argentx: {
		brand: {
			alt: "Argent X Wallet",
			primaryColor: "#FF875B",
			spriteId: "argentx"
		},
		desktop: {
			chromeId: "dlcobpjiigpikoobohmabehhmhfoodbb",
			edgeId: "ajcicjlkibolbeaaagejfhnofogocgcj",
			firefoxId: "argent-x"
		},
		name: "Argent X"
	},
	perawallet: {
		brand: {
			alt: "Pera Wallet",
			spriteId: "pera"
		},
		mobile: {
			androidId: "com.algorand.android",
			iosId: "id1459898525"
		},
		name: "Pera Wallet"
	},
	blocto: {
		brand: {
			alt: "Blocto Wallet",
			primaryColor: "#5E678A",
			spriteId: "blocto"
		},
		chainGroup: "blocto",
		group: "blocto",
		mobile: {
			androidId: "com.portto.blocto",
			iosId: "id1481181682"
		},
		name: "Blocto",
		shortName: "Blocto (Flow)"
	},
	solflare: {
		brand: {
			alt: "Solflare Wallet",
			primaryColor: "#FC7227",
			spriteId: "solflare"
		},
		chains: [
			"solana:4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z",
			"solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp",
			"solana:EtWTRABZaYq6iMfeYKouRu166VU2xqa1"
		],
		desktop: {
			chromeId: "bhhhlbepdkbapadjdnnojkbgioiodbic"
		},
		filterFromWalletConnect: true,
		hardwareWallets: [
			"ledger"
		],
		injectedConfig: [
			{
				chain: "sol",
				extensionLocators: [
					{
						flag: "isSolflare",
						value: true
					}
				],
				windowLocations: [
					"solflare"
				]
			}
		],
		mobile: {
			androidId: "com.solflare.mobile",
			iosId: "id1580902717"
		},
		name: "Solflare",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		},
		walletLimitations: {
			browserExtension: {
				unsupportedMethods: [
					"getConnectedAccounts"
				]
			}
		}
	},
	braavos: {
		brand: {
			alt: "Braavos Wallet",
			primaryColor: "#FABB38",
			spriteId: "braavos"
		},
		desktop: {
			chromeId: "jnlgamecbpmbajjfhmmmlhejkemejdma",
			edgeId: "hkkpjehhcnhgefhbdcgfkeegglpjchdc",
			firefoxId: "braavos-wallet"
		},
		injectedConfig: [
			{
				chain: "starknet",
				extensionLocators: [
				],
				windowLocations: [
					"braavos"
				]
			}
		],
		mobile: {
			androidId: "app.braavos.wallet",
			inAppBrowser: "https://link.braavos.app/dapp/{{encodedDappURI}}",
			iosId: "id1636013523"
		},
		name: "Braavos"
	},
	trust: {
		brand: {
			alt: "Trust Wallet",
			primaryColor: "#0500FF",
			spriteId: "7677b54f-3486-46e2-4e37-bf8747814f00"
		},
		chains: [
			"cosmos:cosmoshub-4",
			"cosmos:kava-4",
			"cosmos:thorchain-mainnet-v1",
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:108",
			"eip155:1101",
			"eip155:128",
			"eip155:137",
			"eip155:2020",
			"eip155:288",
			"eip155:321",
			"eip155:324",
			"eip155:361",
			"eip155:42161",
			"eip155:42220",
			"eip155:43114",
			"eip155:4689",
			"eip155:56",
			"eip155:56288",
			"eip155:59144",
			"eip155:60",
			"eip155:80084",
			"eip155:80085",
			"eip155:820",
			"eip155:88",
			"eip155:9001",
			"solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp"
		],
		desktop: {
			chromeId: "egjidjbpglichdcondbcbdnbeeppgdph"
		},
		eip6963Config: {
			rdns: "com.trustwallet.app"
		},
		filterFromWalletConnect: true,
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
					{
						flag: "isTrustWallet",
						value: true
					}
				],
				windowLocations: [
					"trustWallet"
				]
			}
		],
		mobile: {
			androidId: "com.wallet.crypto.trustapp",
			iosId: "id1288339409",
			native: "trust://wc",
			universal: "https://link.trustwallet.com/wc"
		},
		name: "Trust",
		shortName: "Trust",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	rainbow: {
		brand: {
			alt: "Rainbow Wallet",
			primaryColor: "#001e59",
			spriteId: "rainbow"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:42161",
			"eip155:56",
			"eip155:7777777",
			"eip155:80084",
			"eip155:80085",
			"eip155:8453"
		],
		desktop: {
			chromeId: "opfgelmcmbiajamepnmloijbpoleiama",
			edgeId: "cpojfbodiccabbabgimdeohkkpjfpbnf",
			firefoxId: "rainbow-extension"
		},
		eip6963Config: {
			rdns: "me.rainbow"
		},
		filterFromWalletConnect: true,
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
					{
						flag: "isRainbow",
						value: true
					}
				],
				windowLocations: [
					"rainbow"
				]
			}
		],
		mobile: {
			androidId: "me.rainbow",
			iosId: "id1457119021",
			native: "rainbow://wc",
			universal: "https://rnbwapp.com/wc"
		},
		name: "Rainbow",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	dapper: {
		brand: {
			alt: "Dapper Wallet",
			primaryColor: "#762FBE",
			spriteId: "dapper"
		},
		mobile: {
			android: "fake-to-get-dapper-to-appear",
			ios: "fake-to-get-dapper-to-appear"
		},
		name: "Dapper"
	},
	glow: {
		brand: {
			alt: "Glow Wallet",
			spriteId: "glow"
		},
		desktop: {
			chromeId: "ojbcfhjmpigfobfclfflafhblgemeidi",
			edgeId: "niihfokdlimbddhfmngnplgfcgpmlido",
			firefoxId: "glow-solana-wallet"
		},
		hardwareWallets: [
			"ledger"
		],
		injectedConfig: [
			{
				chain: "sol",
				extensionLocators: [
					{
						flag: "isGlow",
						value: true
					}
				],
				windowLocations: [
					"glowSolana"
				]
			}
		],
		name: "Glow"
	},
	lilico: {
		brand: {
			alt: "Lilico Wallet",
			spriteId: "lilico"
		},
		desktop: {
			chromeId: "hpclkefagolihohboafpheddmmgdffjm"
		},
		filterFromWalletConnect: true,
		name: "Lilico"
	},
	flowwalletflow: {
		brand: {
			alt: "Flow Wallet",
			spriteId: "flowwallet"
		},
		chainGroup: "flowwallet",
		desktop: {
			chromeId: "hpclkefagolihohboafpheddmmgdffjm"
		},
		filterFromWalletConnect: true,
		group: "flowwallet",
		name: "Flow Wallet"
	},
	magicemailotp: {
		brand: {
			alt: "Magic Email OTP",
			spriteId: "magiclink"
		},
		name: "Magic Email OTP"
	},
	magiclink: {
		brand: {
			alt: "Magic Link",
			spriteId: "magiclink"
		},
		name: "Magic Link"
	},
	magicsocial: {
		brand: {
			alt: "Magic Social",
			spriteId: "magiclink"
		},
		name: "Magic Social"
	},
	magiceden: {
		brand: {
			alt: "Magic Eden",
			spriteId: "magiceden"
		},
		chainGroup: "magiceden",
		chains: [
			"bip122:000000000019d6689c085ae165831e93",
			"bip122:000000000933ea01ad0ee984209779ba",
			"eip155:1",
			"eip155:137",
			"eip155:80084",
			"eip155:80085",
			"eip155:8453",
			"solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp"
		],
		desktop: {
			chromeId: "mkpegjkblkkefacfnmkajcjmabijhclg"
		},
		eip6963Config: {
			rdns: "io.magiceden.wallet"
		},
		filterFromWalletConnect: true,
		group: "magiceden",
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
					{
						flag: "isMagicEden",
						value: true
					}
				],
				windowLocations: [
					"magicEden.ethereum"
				]
			}
		],
		mobile: {
			androidId: "com.magiceden.wallet",
			inAppBrowser: "magiceden://browser",
			iosId: "id6478631482",
			native: "magiceden://wc",
			universal: "https://magiceden.io/browser"
		},
		name: "Magic Eden"
	},
	magicedenbtc: {
		brand: {
			alt: "Magic Eden",
			spriteId: "magiceden"
		},
		chainGroup: "magiceden",
		desktop: {
			chromeId: "mkpegjkblkkefacfnmkajcjmabijhclg"
		},
		group: "magiceden",
		hardwareWallets: [
			"ledger"
		],
		injectedConfig: [
			{
				chain: "btc",
				extensionLocators: [
				],
				walletStandard: {
					features: [
						"sats-connect:"
					],
					name: "Magic Eden"
				},
				windowLocations: [
					"magicEden.bitcoin"
				]
			}
		],
		mobile: {
			androidId: "com.magiceden.wallet",
			inAppBrowser: "magiceden://browser/{{encodedDappURI}}",
			iosId: "id6478631482",
			universal: "https://magiceden.io/browser/{{encodedDappURI}}"
		},
		mobileExperience: "in-app-browser",
		name: "Magic Eden",
		shortName: "Magic Eden (Bitcoin)",
		walletLimitations: {
			browserExtension: {
				unsupportedMethods: [
					"getConnectedAccounts"
				]
			}
		}
	},
	magicedensol: {
		brand: {
			alt: "Magic Eden",
			spriteId: "magiceden"
		},
		chainGroup: "magiceden",
		desktop: {
			chromeId: "mkpegjkblkkefacfnmkajcjmabijhclg"
		},
		group: "magiceden",
		hardwareWallets: [
			"ledger"
		],
		injectedConfig: [
			{
				chain: "sol",
				extensionLocators: [
					{
						flag: "isMagicEden",
						value: true
					}
				],
				windowLocations: [
					"magicEden.solana"
				]
			}
		],
		mobile: {
			androidId: "com.magiceden.wallet",
			inAppBrowser: "magiceden://browser/{{encodedDappURI}}",
			iosId: "id6478631482",
			universal: "https://magiceden.io/browser/{{encodedDappURI}}"
		},
		name: "Magic Eden",
		shortName: "Magic Eden (Solana)",
		walletLimitations: {
			browserExtension: {
				unsupportedMethods: [
					"getConnectedAccounts"
				]
			}
		}
	},
	exodus: {
		brand: {
			alt: "Exodus Wallet",
			spriteId: "4c16cad4-cac9-4643-6726-c696efaf5200"
		},
		chainGroup: "exodus",
		chains: [
			"bip122:000000000019d6689c085ae165831e93",
			"bip122:000000000933ea01ad0ee984209779ba",
			"eip155:1",
			"eip155:137",
			"eip155:43114",
			"eip155:56",
			"eip155:80084",
			"eip155:80085",
			"solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp"
		],
		desktop: {
			chromeId: "aholpfdialjgjfhomihkjbmgjidlcdno"
		},
		filterFromWalletConnect: true,
		group: "exodus",
		mobile: {
			androidId: "exodusmovement.exodus",
			iosId: "id1414384820",
			native: "exodus://wc",
			universal: "https://exodus.com/m/wc"
		},
		name: "Exodus",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	exodusevm: {
		brand: {
			alt: "Exodus Wallet",
			spriteId: "exodus"
		},
		chainGroup: "exodus",
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:43114",
			"eip155:56"
		],
		desktop: {
			chromeId: "aholpfdialjgjfhomihkjbmgjidlcdno"
		},
		eip6963Config: {
			rdns: "com.exodus.web3-wallet"
		},
		filterFromWalletConnect: true,
		group: "exodus",
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
					{
						flag: "isExodus",
						value: true
					}
				]
			}
		],
		mobile: {
			androidId: "exodusmovement.exodus",
			iosId: "id1414384820",
			native: "exodus://wc"
		},
		name: "Exodus",
		shortName: "Exodus Wallet (EVM)",
		walletConnect: {
			sdks: [
				"sign_v2",
				"auth_v1"
			]
		}
	},
	exodussol: {
		brand: {
			alt: "Exodus Wallet",
			spriteId: "exodus"
		},
		chainGroup: "exodus",
		desktop: {
			chromeId: "aholpfdialjgjfhomihkjbmgjidlcdno"
		},
		group: "exodus",
		injectedConfig: [
			{
				chain: "sol",
				extensionLocators: [
					{
						flag: "isPhantom",
						value: true
					},
					{
						flag: "isExodus",
						value: true
					}
				],
				windowLocations: [
					"exodus.solana"
				]
			}
		],
		mobile: {
			androidId: "exodusmovement.exodus",
			iosId: "id1414384820"
		},
		name: "Exodus",
		shortName: "Exodus Wallet (Solana)"
	},
	okxwallet: {
		brand: {
			alt: "OKX Wallet",
			spriteId: "okx"
		},
		chainGroup: "okxwallet",
		chains: [
			"bip122:000000000019d6689c085ae165831e93",
			"bip122:000000000933ea01ad0ee984209779ba",
			"eip155:1",
			"eip155:137",
			"eip155:43114",
			"eip155:56",
			"eip155:66",
			"eip155:80084",
			"eip155:80085",
			"solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp"
		],
		desktop: {
			chromeId: "mcohilncbfahbmgdjkbpemcciiolgcge"
		},
		eip6963Config: {
			rdns: "com.okex.wallet"
		},
		filterFromWalletConnect: true,
		group: "okxwallet",
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
					{
						flag: "isOKExWallet",
						value: true
					},
					{
						flag: "isOkxWallet",
						value: true
					}
				],
				windowLocations: [
					"okxwallet"
				]
			}
		],
		mobile: {
			androidId: "com.okinc.okex.gp",
			iosId: "id1327268470",
			native: "okex://main/wc"
		},
		name: "OKX Wallet",
		shortName: "OKX Wallet",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	backpack: {
		brand: {
			alt: "Backpack",
			primaryColor: "#e43c3c",
			spriteId: "backpack"
		},
		chainGroup: "backpack",
		chains: [
			"eip155:1",
			"eip155:80084",
			"eip155:80085",
			"solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp"
		],
		desktop: {
			chromeId: "aflkmfhebedbjioipglgcbcmnbpgliof"
		},
		eip6963Config: {
			rdns: "app.backpack"
		},
		filterFromWalletConnect: true,
		group: "backpack",
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
					{
						flag: "isBackpack",
						value: true
					}
				],
				windowLocations: [
				]
			}
		],
		mobile: {
			androidId: "app.backpack.mobile",
			iosId: "id6445964121",
			native: "backpack://wc"
		},
		name: "Backpack",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	okxwalletbtc: {
		brand: {
			alt: "OKX Wallet",
			spriteId: "okx"
		},
		chainGroup: "okxwallet",
		desktop: {
			chromeId: "mcohilncbfahbmgdjkbpemcciiolgcge"
		},
		group: "okxwallet",
		injectedConfig: [
			{
				chain: "btc",
				extensionLocators: [
				],
				windowLocations: [
					"okxwallet.bitcoin"
				]
			}
		],
		mobile: {
			androidId: "com.okinc.okex.gp",
			inAppBrowser: "okx://wallet/dapp/url?dappUrl={{encodedDappURI}}",
			iosId: "id1327268470"
		},
		mobileExperience: "in-app-browser",
		name: "OKX Wallet",
		shortName: "OKX Wallet (Bitcoin)",
		walletLimitations: {
			browserExtension: {
				unsupportedMethods: [
					"getConnectedAccounts"
				]
			}
		}
	},
	unisat: {
		brand: {
			alt: "UniSat",
			spriteId: "unisat"
		},
		desktop: {
			chromeId: "ppbibelpcjmhbdihakflkdcoccbgbkpo"
		},
		injectedConfig: [
			{
				chain: "btc",
				extensionLocators: [
				],
				windowLocations: [
					"unisat"
				]
			}
		],
		name: "UniSat"
	},
	unknown: {
		brand: {
			spriteId: "unknown-wallet"
		},
		mobile: {
			androidId: "enable-android",
			iosId: "id1234567890"
		},
		name: "Unknown Wallet",
		walletLimitations: {
			browserExtension: {
				unsupportedMethods: [
					"getConnectedAccounts"
				]
			}
		}
	},
	xverse: {
		brand: {
			alt: "Xverse Wallet",
			spriteId: "xverse"
		},
		desktop: {
			chromeId: "idnnbdplmphpflfnlkomgpfbpcgelopg"
		},
		hardwareWallets: [
			"ledger"
		],
		injectedConfig: [
			{
				chain: "btc",
				extensionLocators: [
				],
				walletStandard: {
					features: [
						"sats-connect:"
					],
					name: "Xverse",
					providerId: "XverseProviders.BitcoinProvider"
				},
				windowLocations: [
					"XverseProviders.BitcoinProvider"
				]
			}
		],
		mobile: {
			androidId: "com.secretkeylabs.xverse",
			inAppBrowser: "xverse://browser?url={{encodedDappURI}}",
			iosId: "id1552272513"
		},
		name: "Xverse",
		walletLimitations: {
			browserExtension: {
				unsupportedMethods: [
					"getConnectedAccounts"
				]
			}
		}
	},
	fallbackconnector: {
		brand: {
			spriteId: "unknown-wallet"
		},
		mobile: {
			androidId: "enable-android",
			iosId: "id1234567890"
		},
		name: "Fallback Connector",
		walletLimitations: {
			browserExtension: {
				unsupportedMethods: [
					"getConnectedAccounts"
				]
			}
		}
	},
	oylwallet: {
		brand: {
			alt: "Oyl Wallet",
			spriteId: "oyl"
		},
		desktop: {
			chromeId: "ilolmnhjbbggkmopnemiphomhaojndmb"
		},
		injectedConfig: [
			{
				chain: "btc",
				extensionLocators: [
				],
				windowLocations: [
					"oyl"
				]
			}
		],
		name: "Oyl Wallet"
	},
	abstract: {
		brand: {
			alt: "Abstract",
			spriteId: "abstract"
		},
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
				]
			}
		],
		name: "Abstract"
	},
	edenonline: {
		brand: {
			alt: "Eden Online",
			spriteId: "edenonline"
		},
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
				]
			}
		],
		name: "Eden Online"
	},
	onekeybtc: {
		brand: {
			alt: "OneKey Wallet",
			spriteId: "onekey"
		},
		chainGroup: "onekey",
		desktop: {
			chromeId: "jnmbobjmhlngoefaiojfljckilhhlhcj"
		},
		group: "onekey",
		injectedConfig: [
			{
				chain: "btc",
				extensionLocators: [
				],
				windowLocations: [
					"$onekey.btc"
				]
			}
		],
		mobile: {
			androidId: "so.onekey.app.wallet",
			iosId: "id1609559473"
		},
		mobileExperience: "in-app-browser",
		name: "OneKey"
	},
	intersend: {
		brand: {
			alt: "Intersend",
			spriteId: "intersend"
		},
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
				]
			}
		],
		name: "Intersend"
	},
	okxeclipse: {
		brand: {
			alt: "OKX Wallet",
			primaryColor: "#FABB38",
			spriteId: "okx"
		},
		chainGroup: "okxwallet",
		desktop: {
			chromeId: "mcohilncbfahbmgdjkbpemcciiolgcge"
		},
		group: "okxwallet",
		injectedConfig: [
			{
				chain: "eclipse",
				extensionLocators: [
					{
						flag: "isOKExWallet",
						value: true
					},
					{
						flag: "isOkxWallet",
						value: true
					}
				],
				windowLocations: [
					"okxwallet.solana"
				]
			}
		],
		mobile: {
			androidId: "com.okinc.okex.gp",
			inAppBrowser: "okx://wallet/dapp/url?dappUrl={{encodedDappURI}}",
			iosId: "id1327268470"
		},
		name: "OKX Wallet"
	},
	dynamicwaas: {
		brand: {
			alt: "Dynamic Waas",
			primaryColor: "#4779ff",
			spriteId: "dynamicwaas"
		},
		name: "Dynamic Waas"
	},
	nightlyeclipse: {
		brand: {
			alt: "Nightly Wallet",
			spriteId: "nightly"
		},
		chainGroup: "nightly",
		desktop: {
			chromeId: "fiikommddbeccaoicoejoniammnalkfa",
			edgeId: "fiikommddbeccaoicoejoniammnalkfa",
			operaId: "fiikommddbeccaoicoejoniammnalkfa"
		},
		group: "nightly",
		hardwareWallets: [
			"ledger"
		],
		injectedConfig: [
			{
				chain: "eclipse",
				extensionLocators: [
				],
				walletStandard: {
					features: [
						"standard:connect",
						"standard:disconnect",
						"solana:signMessage",
						"solana:signTransaction",
						"solana:signAndSendTransaction"
					],
					name: "Nightly"
				}
			}
		],
		name: "Nightly"
	},
	bitgetwalletbtc: {
		brand: {
			alt: "Bitget Wallet",
			spriteId: "bitgetwallet"
		},
		chainGroup: "bitgetwallet",
		group: "bitgetwallet",
		injectedConfig: [
			{
				chain: "btc",
				extensionLocators: [
				],
				windowLocations: [
					"bitkeep.unisat"
				]
			}
		],
		name: "Bitget Wallet"
	},
	backpackeclipse: {
		brand: {
			alt: "Backpack",
			primaryColor: "#e43c3c",
			spriteId: "backpack"
		},
		chainGroup: "backpack",
		desktop: {
			chromeId: "aflkmfhebedbjioipglgcbcmnbpgliof"
		},
		group: "backpack",
		hardwareWallets: [
			"ledger"
		],
		injectedConfig: [
			{
				chain: "eclipse",
				extensionLocators: [
					{
						flag: "isBackpack",
						value: true
					}
				],
				windowLocations: [
					"backpack"
				]
			}
		],
		name: "Backpack"
	},
	binancewalletbtc: {
		brand: {
			alt: "Binance Wallet",
			spriteId: "binance"
		},
		chainGroup: "binance",
		group: "binance",
		injectedConfig: [
			{
				chain: "btc",
				extensionLocators: [
				],
				windowLocations: [
					"binancew3w.bitcoin"
				]
			}
		],
		name: "Binance Wallet",
		shortName: "Binance"
	}
};
var walletBookFallbacks = {
	groups: groups,
	wallets: wallets
};

export { walletBookFallbacks as default, groups, wallets };
